/* eslint-disable @typescript-eslint/naming-convention */
import { ThemeOverrideResolver } from "../helpers/CustomThemeBuilder";

/** Shared AIP (Quick Checkout) positive CTA gradient used across cart/payment CTAs. */
export const AIP_POSITIVE_GRADIENT = "linear-gradient(266deg, #1BA672 2.25%, #005133 98.16%)";

export const AIP_FLOW_THEME_OVERRIDES: Record<"AIP", ThemeOverrideResolver> = {
    AIP: {
        positive: AIP_POSITIVE_GRADIENT,
    },
};
